import {
  Tabs,
  TabsHeader,
  TabsBody,
  Tab,
  TabPanel,
  Typography,
} from "@material-tailwind/react";
import dayjs from 'dayjs';
// import 'moment/locale/th'

import React, { useEffect, useState } from "react";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import EPWeekPicker from "./EPWeekPicker";
import { SettingContext } from "../App";
import weekOfYear from 'dayjs/plugin/weekOfYear'
import advancedFormat from "dayjs/plugin/advancedFormat"
import weekday from "dayjs/plugin/weekday"
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";


dayjs.extend(advancedFormat)
dayjs.extend(weekOfYear)
dayjs.extend(weekday)

// dayjs.locale("th");
// dayjs.extend(buddhistEra);

export default function TimeRangeCaseCountSetting() {

    const { state, setting, setSetting } = React.useContext(SettingContext);
    
    const [activeTab, setActiveTab] = useState(state.setting.case_count.time_range.selected);

    const start_week = state.setting.case_count.time_range.W.start.split('-');
    const [startWeek, setStartWeek] = useState(dayjs().year(start_week[0]).week(start_week[1]).day(0));

    const end_week = state.setting.case_count.time_range.W.end.split('-');
    const [endWeek, setEndWeek] = useState(dayjs().year(end_week[0]).week(end_week[1]).day(0));

    const start_month = state.setting.case_count.time_range.M.start.split('-');
    const [startMonth, setStartMonth] = useState(dayjs().year(start_month[0]).month(start_month[1]-1));

    const end_month = state.setting.case_count.time_range.W.end.split('-');
    const [endMonth, setEndMonth] = useState(dayjs().year(end_month[0]).week(end_month[1]));

    const data = [
    {
        label: "สัปดาห์",
        value: "W",
    },
    {
        label: "เดือน",
        value: "M",
    },
    ];

    const handleTabChange = (value) => {
        if(value !== setting.case_count.time_range.selected){
            setActiveTab(value)
            let _setting = {...setting}
            _setting.case_count.time_range.selected = value
            setSetting(_setting)
            // dispatch({
            //     type: "ON_SETTING_CHANGE",
            //     payload: _setting
            // })
        }
    }

    const handleStartWeekSelected = (newValue) => {
        const week_start = dayjs(newValue).day(0)
        setStartWeek(week_start) 
        if(setting.case_count.time_range.W.start !== week_start.format('YYYY-ww')){
            let _setting = {...setting}
            _setting.case_count.time_range.W.start = week_start.format('YYYY-ww')
            //--------------------------
            //-----Set last selected
            setSetting(_setting)
            //-------------------------
            // dispatch({
            //     type: "ON_SETTING_CHANGE",
            //     payload: _setting
            // })
        }
    }

    const handleEndWeekSelected = (newValue) => {
        const week_end = dayjs(newValue).day(0)
        setEndWeek(week_end)
        // setEndWeek(newValue.add(newValue.$W*-1, "day")) 
        if(setting.case_count.time_range.W.end !== week_end.format('YYYY-ww')){
            let _setting = {...setting}
            _setting.case_count.time_range.W.end = week_end.format('YYYY-ww')
            setSetting(_setting)
            // dispatch({
            //     type: "ON_SETTING_CHANGE",
            //     payload: _setting
            // })
        }
    }

    const handleStartMonthSelected = (newValue) => {
        setStartMonth(newValue) 
        if(setting.case_count.time_range.M.start !== newValue.format('YYYY-MM')){
            let _setting = {...setting}
            _setting.case_count.time_range.M.start = newValue.format('YYYY-MM')
            setSetting(_setting)
            // dispatch({
            //     type: "ON_SETTING_CHANGE",
            //     payload: _setting
            // })
        }
    }

    const handleEndMonthSelected = (newValue) => {
        setEndMonth(newValue) 
        if(setting.case_count.time_range.M.end !== newValue.format('YYYY-MM')){
            let _setting = {...state.setting}
            _setting.case_count.time_range.M.end = newValue.format('YYYY-MM')
            setSetting(_setting)
            // dispatch({
            //     type: "ON_SETTING_CHANGE",
            //     payload: _setting
            // })
        }
    }

    const shortcutsItems = [
        {
            label: 'เดือนปัจจุบัน',
            getValue: () => {
                return dayjs()
            },
        },
    ]

    return (
        <div>
            <Typography className="font-primary mb-2 mt-4 font-bold">ช่วงเวลาการแสดงผล</Typography>
            <Tabs id="time-range-animation" value={activeTab}>
                <TabsHeader
                    id="time-range-tabs-header" 
                    
                    className="rounded-[4px] bg-red-50 border-red-200 border"
                    indicatorProps={{
                    className: "bg-red-900 shadow-none !text-gray-900",
                    }}
                >
                    {data.map(({ label, value }) => (
                    <Tab id="time-range-tab"
                        onClick={() => handleTabChange(value)}
                        className="font-primary"
                        activeClassName="text-white font-primary"
                        key={value}
                        value={value}
                    >
                        {label}
                    </Tab>
                    ))}
                </TabsHeader>
                <TabsBody
                    animate={{
                    initial: { y: 60 },
                    mount: { y: 0 },
                    unmount: { y: 60 },
                    }}
                >
                    <TabPanel key="W" value="W" className="px-0">
                        <div className="grid w-full grid-cols-2 gap-2">
                            <EPWeekPicker 
                                label="สัปดาห์เริ่มต้น" 
                                maxDate={endWeek.add(6-endWeek.$W, "day")} 
                                minDate={dayjs().month(0).year(Number(process.env.REACT_APP_CASE_START_YEAR)).day(0)} 
                                onChange={handleStartWeekSelected} value={startWeek}
                            />
                            <EPWeekPicker label="สัปดาห์สิ้นสุด" minDate={startWeek.add(startWeek.$W*-1, "day")} maxDate={dayjs().day(6)} onChange={handleEndWeekSelected} value={endWeek} />
                        </div>
                    </TabPanel>
                    <TabPanel key="M" value="M" className="px-0">
                        <div className="grid w-full grid-cols-2 gap-2">
                            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="th" dateFormats={{ monthAndYear: 'MMMM BBBB', year: 'BBBB' }} >
                                <DatePicker 
                                    slotProps={{ 
                                        textField: { size: 'small', InputLabelProps:{className:"font-primary"}, inputProps:{value: `${startMonth.format('MM/BBBB')}`}},
                                        shortcuts:{
                                            items: shortcutsItems,
                                        }, 
                                    }} 
                                    label={'เดือนเริ่มต้น'} 
                                    views={["month", "year"]}      
                                    enableAccessibleFieldDOMStructure={false}
                                    onChange={handleStartMonthSelected}
                                    value={startMonth}
                                    maxDate={endMonth}
                                    minDate={dayjs().month(0).year(Number(process.env.REACT_APP_CASE_START_YEAR))}
                                /> 
                                <DatePicker 
                                    slotProps={{ 
                                        textField: { size: 'small', InputLabelProps:{className:"font-primary"}, inputProps:{value: `${endMonth.format('MM/BBBB')}`}},
                                        shortcuts:{
                                            items: shortcutsItems,
                                        }, 
                                    }}  
                                    label={'เดือนสิ้นสุด'} 
                                    views={["month", "year"]}
                                    enableAccessibleFieldDOMStructure={false}
                                    onChange={handleEndMonthSelected}
                                    value={endMonth}
                                    minDate={startMonth}
                                    maxDate={dayjs()}
                                /> 
                            </LocalizationProvider>
                        </div>
                    </TabPanel>
                </TabsBody>
            </Tabs>
        </div>
        
    );
}
